import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'mia-info-dialog',
  templateUrl: './info-service-dialog.component.html',
  styleUrls: ['./info-service-dialog.component.css']
})
export class InfoServiceDialogComponent {

  @Input() process: Array<ProcessDetail> = [];
  @Input() success: boolean = false;

}

export class ProcessDetail {
  public task: string;
  public status?: boolean = false;
}
